(function () {
  "use strict";

  // Chooses between the React Customers page and the legacy Angular controller,
  // gated per-tenant by the `react-customers` feature flag. A missing flag
  // evaluates to control (off), so tenants stay on Angular until the flag is
  // created and ramped in the Features UI.
  angular.module("app").component("customersDispatch", {
    bindings: {
      showDeleted: "<"
    },
    controller: CustomersDispatchController,
    template:
      '<div ng-if="$ctrl.resolved">' +
      '  <customers-page ng-if="$ctrl.reactEnabled" show-deleted="$ctrl.showDeleted"></customers-page>' +
      '  <div ng-if="!$ctrl.reactEnabled" ng-include="$ctrl.legacyTemplateUrl"></div>' +
      '</div>'
  });

  CustomersDispatchController.$inject = ["featureFlagService", "version"];

  function CustomersDispatchController(featureFlagService, version) {
    var vm = this;

    vm.$onInit = function () {
      vm.legacyTemplateUrl = "/views/Customers/Index.html?v=" + version;
      featureFlagService.reactCustomers().then(function (enabled) {
        vm.reactEnabled = enabled;
        vm.resolved = true;
      });
    };
  }
})();
